import React, {useEffect, useMemo, useState} from 'react';
import {
  type MRT_ColumnFiltersState,
  type MRT_PaginationState,
  type MRT_SortingState,
  MRT_EditActionButtons,
  MaterialReactTable,
  MRT_EditCellTextField,
  createRow,
  type MRT_ColumnDef,
  type MRT_Row,
  type MRT_TableOptions,
  useMaterialReactTable, MRT_SelectCheckbox,
} from 'material-react-table';
import {
    Box,
    Button,
    DialogActions,
    DialogContent,
    Dialog,
    DialogTitle, Grid,
    IconButton, TextField,
    Tooltip, Typography, Snackbar, Alert,
} from '@mui/material';
import {
  QueryClient,
} from '@tanstack/react-query';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ArticleIcon from '@mui/icons-material/Article';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import PreviewIcon from '@mui/icons-material/Preview';
import AddBoxIcon from '@mui/icons-material/AddBox';
import FileCopyIcon from '@mui/icons-material/FileCopy';

import {useNavigate} from "react-router-dom";
import {PrevTesta, PrevTestaDTO} from "./types";
import {
    useCreaProg,
    useDeletePrevTesta, useDuplicaPrev, useGeneraAnalisiRequisiti, useGetAllPrevTestaDTObyDip
} from "./Services";
import PreventiviAdd from "./PreventiviAdd";
import PreventiviEdit from "./PreventiviEdit";
import PreventiviSE from "./PreventiviSE";
import PreventiviCE from "./PreventiviCE";
import PreventiviRE from "./PreventiviRE";


interface PreventiviProps {
  propflgtemp: string;
}


// const Preventivi = () => {
const Preventivi: React.FC<PreventiviProps> = ({ propflgtemp }) => {
  const [validationErrors, setValidationErrors] = useState< Record<string, string | undefined>>({});
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>([],);
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({pageIndex: 0, pageSize: 15, });

  const [isFilteredByTemp, setIsFilteredByTemp] = useState(false); // State to track if TEMP filter is applied

  // Add function to toggle TEMP filter

   const isAdmin = localStorage.getItem('isadmin');
   const storeCodDip = localStorage.getItem('coddip');
   const storeUsername = localStorage.getItem('keyusername');


  const navigate = useNavigate();

  const columns = useMemo<MRT_ColumnDef<PrevTestaDTO>[]>(
    () => [
        {
            accessorKey: 'id',
            header: 'Id',
            size: 1,
            enableEditing: false,
        },
        {
          accessorKey: 'dataprev',
          header: 'Data',
          enableEditing: true,
          filterVariant: "date-range",
          size: 5,
          Cell: ({cell}) => {
              const value = cell.getValue();
              if (value && (typeof value === 'string' || typeof value === 'number' || value instanceof Date)) {
                  const date = new Date(value);
                  return new Intl.DateTimeFormat('it-IT', {day: '2-digit',  month: '2-digit', year: '2-digit' }).format(date);
              } else {
                  return '';
              }
          }
        },
        {
                accessorKey: 'codditta',
                header: 'Ditta',
                size: 1,
                enableEditing: false,
                Cell: ({ cell }) => {
                    return cell.getValue() === 2 ? "BS" : "IN4IT";
                }
         },
        //  {
        //     accessorKey: 'codprev',
        //     header: 'Cod.Prev.',
        //     size: 5,
        //     enableEditing: false,
        // },

         {
            accessorKey: 'codref',
            header: 'Ref.',
            size: 1,
            enableEditing: false,
          },

     { accessorKey: 'desprev', header: 'Des.Preventivo', size: 2, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 40 ? `${value.substring(0, 40)}...` : value}</span> ); }, },

       //  {
       //      accessorKey: 'codcli',
       //      header: 'Cod.Cli.',
       //      enableEditing: false,
       //      size: 5,
       // },
      { accessorKey: 'descli', header: 'Cliente', size: 2, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 40 ? `${value.substring(0, 40)}...` : value}</span> ); }, },

      { accessorKey: 'note', header: 'Note', size: 2, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 40 ? `${value.substring(0, 40)}...` : value}</span> ); }, },

      // {
      //       accessorKey: 'note',
      //       header: 'Note',
      //       size: 5,
      //       enableEditing: false,
      // },
      {
            accessorKey: 'codprog',
            header: 'Cod.Prog',
            size: 5,
            enableEditing: false,
      },
      {
             accessorKey: 'numord',
             header: 'Num.Ord.',
             size: 5,
             enableEditing: false,
      },

      {
            accessorKey: 'flgval',
            header: 'Flag.Val.',
            size: 5,
            enableEditing: false,
      },


      
    //  {
    //     accessorKey: 'datanascita',
    //     header: 'DataNascita',
    //     enableEditing: true,
    //     size: 5,
    //     //filterVariant: 'date-range',
    //      Cell: ({ cell }) => {
    //         const value = cell.getValue();
    //         if (typeof value === 'string' || typeof value === 'number') {
    //             const date = new Date(value);
    //             return date.toLocaleDateString('it-IT'); // Change 'it-IT' to your desired locale
    //         } else {
    //             // Handle unexpected value types
    //             return "Nessuna Data";
    //         }
    //         }
    // },
    

    ],
    [validationErrors],
  );

  //call READ hook
  const {  data: { results = [], count } = {} ,isError: isLoadingPrevTestaError, isFetching: isFetchingPrevTesta, isLoading: isLoadingPrevTesta, } = useGetAllPrevTestaDTObyDip(pagination,columnFilters,globalFilter,sorting,propflgtemp);

  // const {  mutateAsync: creaProg, isPending: creaProgLoading, data: creaProgData,  error: creaProgError,} = useCreaProg();

  const { mutateAsync: creaProg, data: creaProgData, error: creaProgError, isPending: creaProgLoading } = useCreaProg();

  const { mutateAsync: analisiRequisiti, data: analisiRequisitiData, error: analisiRequisitiError, isPending: analisiRequisitiLoading } = useGeneraAnalisiRequisiti();

  const [snackbarMsg, setSnackbarMsg] = useState<string | null>(null);



  const { mutateAsync: deletePrevTesta, isPending: isDeletingPrevTesta } = useDeletePrevTesta();
  
  const { mutateAsync: duplicaPrev, isPending: isDuplicaPrev } = useDuplicaPrev();

  //new call Edit hook
  const [isDialogEditOpen, setIsDialogEditOpen] = useState(false);
  const [currentRowId, setCurrentRowId] = useState('0');
  const [currentCodDitta, setCurrentCodDitta] = useState('0');
  //new call Add hook
  const [isDialogAddOpen, setIsDialogAddOpen] = useState(false);
  const [isDialogPrevTestaOpen, setIsDialogPrevTestaOpen] = useState(false);
  const [param, setParam] = useState('0');
  const [isDialogPrevTestaExpOpen, setIsDialogPrevTestaExpOpen] = useState(false);
  const [isDialogServElemOpen, setIsDialogServElemOpen] = useState(false);
  const [isDialogCustElemOpen, setIsDialogCustElemOpen] = useState(false);
  const [isDialogPrevRepoOpen, setIsDialogPrevRepoOpen] = useState(false);


  const [selectedRow, setSelectedRow] = useState<PrevTestaDTO>()

  //DELETE action
  const openDeleteConfirmModal = (row: MRT_Row<PrevTestaDTO>) => {
    if (window.confirm('ATTENZIONE !!! CANCELLAZIONE DEL PREVENTIVO " '+row.original.id+' '+row.original.id+' "')) {
      deletePrevTesta(row.original.id ? row.original.id : 0 );
    }
  };

const handleDuplicaPrev = async (row: MRT_Row<PrevTestaDTO>) => {
  if (window.confirm('ATTENZIONE !!! DUPLICA DEL PREVENTIVO N. ' + row.original.id )) {
    try {
      await duplicaPrev({
        id: row.original.id ? row.original.id : 0,
        coddip: storeCodDip ? storeCodDip : '',
      });
      // Optionally handle success here
    } catch (error) {
      // Optionally handle error here
      console.error('Duplica failed:', error);
    }
  }
};


   const handleFilterTemp = () => {
    if (isFilteredByTemp) {
      // Remove the TEMP filter if it's already applied
      setColumnFilters((prev) => prev.filter((filter) => filter.id !== 'flgtemp'));
    } else {
      // Apply the TEMP = 'Y' filter
      setColumnFilters((prev) => [...prev, { id: 'flgtemp', value: 'Y' }]);
    }
    setIsFilteredByTemp(!isFilteredByTemp);
  };

  
  
  

  const openServElemModal = (row: MRT_Row<PrevTestaDTO>) => {
       setIsDialogServElemOpen(true);
       setSelectedRow(row.original);
       setCurrentRowId(row.id);
   };

  const openCustElemModal = (row: MRT_Row<PrevTestaDTO>) => {
       setIsDialogCustElemOpen(true);
       setSelectedRow(row.original);
       setCurrentRowId(row.id);
   };

  const openPrevRepoModal = (row: MRT_Row<PrevTestaDTO>) => {
       setIsDialogPrevRepoOpen(true);
       setSelectedRow(row.original);
       setCurrentRowId(row.id);
   };



  //NEW MOD action
   const openEditModal = (row: MRT_Row<PrevTestaDTO>) => {
       setIsDialogEditOpen(true);
       setCurrentRowId(row.id);
       setSelectedRow(row.original);
   };


   const openPrevTestaModal = (row: MRT_Row<PrevTestaDTO>) => {
       setIsDialogPrevTestaOpen(true);
       setSelectedRow(row.original);
       setCurrentRowId(row.id);
   };


  //NEW ADD action hook and dialog
  const openAddModal = () => {
        setIsDialogAddOpen(true);

  };





  const openPrevTestaExpModal = () => {
        setIsDialogPrevTestaExpOpen(true);
  };


  useEffect(() => {
  if (creaProgData) {
    setSnackbarMsg(`Progetto generato con successo: ${JSON.stringify(creaProgData)}`);
  } else if (creaProgError) {
    setSnackbarMsg(`Errore: ${(creaProgError as Error).message || 'Unknown error'}`);
  }
}, [creaProgData, creaProgError]);



  const table = useMaterialReactTable({
    columns,
    data: results,
    initialState: { density: 'compact' },

    manualFiltering: true, //turn off built-in client-side filtering
    manualPagination: true, //turn off built-in client-side pagination
    manualSorting: true, //turn off built-in client-side sorting

    createDisplayMode: 'modal', //default ('row', and 'custom' are also available)
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)
    enableEditing: true,
    // enableColumnActions: false,


    //getRowId: (row) => row.id.toString(),

    getRowId: (row) => (row.id ? row.id.toString() : ''),



    muiToolbarAlertBannerProps: isLoadingPrevTestaError ? {
          color: 'error',
          children: 'Error loading data',
        } : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: '500px',
      },
    },
    // muiEditRowDialogProps: {
    //    fullWidth: true,
    //    maxWidth: 'md',
    //  },
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onCreatingRowCancel: () => setValidationErrors({}),
    onEditingRowCancel: () => setValidationErrors({}),

     renderCreateRowDialogContent: ({ table, row, internalEditComponents }) => (
         <>
        <DialogTitle variant="h3">Crea Nuovo PrevTesta</DialogTitle>
        <DialogContent
           sx={{ width: '1000px'}}
        >
          {internalEditComponents} {/* or render custom edit components here */}

        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>

       </>
    ),


   renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">Edit PrevTesta</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),

 renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '0.20rem' }}>

          {/* Show the button unless isAdmin is false and flgtemp is Y */}
    {!(isAdmin === 'false' && row.original.flgtemp === 'Y') && (
      <>
        <Tooltip title="Modifica">
          <IconButton onClick={() => { openEditModal(row); }}>
            <EditIcon />
          </IconButton>
        </Tooltip>


      </>
    )}

{!(isAdmin === 'false' && row.original.flgtemp === 'Y') && (
       <Tooltip title="Rimuovi">
          <IconButton color="error"  onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
    )}

{!(isAdmin === 'false' && row.original.flgtemp === 'Y') && (
          <Tooltip title="Serv.Elem.">
          <IconButton onClick={() => openServElemModal(row)}>
            <FactCheckIcon />
          </IconButton>
        </Tooltip> )}


{!(isAdmin === 'false' && row.original.flgtemp === 'Y') && (
         <Tooltip title="Att.Agg.">
          <IconButton  onClick={() => openCustElemModal(row)}>
            <AddBoxIcon />
          </IconButton>
        </Tooltip> )}



         <Tooltip title="Duplica">
          <IconButton  onClick={() => handleDuplicaPrev(row)}>
            <FileCopyIcon />
          </IconButton>
        </Tooltip>



         <Tooltip title="Anteprima">
          <IconButton  onClick={() => openPrevRepoModal(row)}>
            <PreviewIcon />
          </IconButton>
        </Tooltip>


{( (storeUsername === 'michael.pinchi' || storeUsername === 'timeadmin') && row.original.flgtemp === 'N') && (
  <Tooltip title="Genera Progetto">
    <IconButton
      onClick={async () => {
        const pwd = window.prompt('Inserisci la password di conferma:');
        if (pwd !== 'm') { // change to your logic
          alert('Password errata!');
          return;
        }

        try {
            await creaProg(Number(row.id));
        } catch (err) {
          console.error('Error during creaProg:', err);
        }
      }}
    >
      <ArticleIcon color="error" />
    </IconButton>
  </Tooltip>
)
}
 {( (storeUsername === 'michael.pinchi' || storeUsername === 'timeadmin') && row.original.flgtemp === 'N') && (
         <Tooltip title="Genera Analisi Requsiti">
    <IconButton
      onClick={async () => {
        // const pwd = window.prompt('Inserisci la password di conferma:');
        // if (pwd !== 'm') { // change to your logic
        //   alert('Password errata!');
        //   return;
        // }

        try {
            await analisiRequisiti(Number(row.id));
        } catch (err) {
          console.error('Error during creaProg:', err);
        }
      }}
    >
      <ArticleIcon color="error" />
    </IconButton>
  </Tooltip>
    )

    }
    </Box>
  ),


    renderTopToolbarCustomActions: ({ table }) => (
      <>
       {propflgtemp=='Y' && isAdmin == 'true' &&  (<Button variant="contained" onClick={openAddModal}>Nuovo Template</Button>)}
       {propflgtemp=='Y' && isAdmin == 'false' &&  (<div> </div>)}
       {propflgtemp=='N' && (<Button variant="contained" onClick={openAddModal}>Nuovo Preventivo</Button>)}



           </>
      ),





    //rowCount: meta?.totalRowCount ?? 0,
    rowCount: count ?? 0,

    state: {
      isLoading: isLoadingPrevTesta,
      // isSaving: isCreatingPrevTesta || isUpdatingPrevTesta || isDeletingPrevTesta,
      isSaving:  isDeletingPrevTesta,
      showAlertBanner: isLoadingPrevTestaError,
      showProgressBars: isFetchingPrevTesta,

      columnFilters,
      globalFilter,
      pagination,
      sorting,
    },
  });

  return  (  <Box sx={{mt: '60px' // , width: '1376px'
        }}><MaterialReactTable table={table} />

<Snackbar
  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
  open={!!snackbarMsg}
  autoHideDuration={6000}
  onClose={() => setSnackbarMsg(null)}
>
  <Alert
    onClose={() => setSnackbarMsg(null)}
    severity="success" // Green background
    sx={{ width: '100%' }}
    variant="filled"
  >
    {snackbarMsg}
  </Alert>
</Snackbar>


       {isDialogEditOpen  &&  <PreventiviEdit  idprevtestaprop={Number(currentRowId)}  coddittaprop={selectedRow?.codditta ? selectedRow?.codditta : 0 }            onClose={() => setIsDialogEditOpen(false)} /> }

       {isDialogServElemOpen &&  <PreventiviSE idprevtesta={(Number(currentRowId))} onClose={()  => setIsDialogServElemOpen(false) } />}

       {isDialogPrevRepoOpen && <PreventiviRE idprevtestaprop={(Number(currentRowId))} onClose={()  => setIsDialogPrevRepoOpen(false) } />}

       {isDialogCustElemOpen  && <PreventiviCE idprevtestaprop={(Number(currentRowId))} onClose={()  => setIsDialogCustElemOpen(false) } />}

       {isDialogAddOpen &&  <PreventiviAdd propflgtemp={propflgtemp}  onClose={() => {setIsDialogAddOpen(false); }} />}


  </Box>
)
};


const queryClient = new QueryClient();

// const PreventiviWithProviders = () => (
//   //Put this with your other react-query providers near root of your app
//   <QueryClientProvider client={queryClient}>
//     <Preventivi />
//   </QueryClientProvider>
// );

export default Preventivi;

